<template>
  <div v-if="car.lastState && car.lastState.lat && !track.length">
    <l-marker :z-index-offset="isSelected ? 99 : 2" :lat-lng="[car.lastState.lat.value, car.lastState.lng.value]" @click="selectCar(car.id)">
      <l-icon v-if="isSelected"
        :icon-url="require('@/assets/icons/selectedMarker.svg')"
        :icon-retina-url="require('@/assets/icons/selectedMarker.svg')"
        :shadow-url="require('leaflet/dist/images/marker-shadow.png')"
      />
    </l-marker>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MapMarker',
  props: ['car'],
  methods: {
    ...mapActions('taxi/mapcars', [
      'selectCar'
    ])
  },
  computed: {
    isSelected () {
      return this.selectedCar && this.selectedCar.id === this.car.id
    },
    ...mapState('taxi/mapcars', {
      selectedCar: state => state.items.find(car => state.selectedCar && car.id === state.selectedCar.id),
      track: state => state.track
    })
  }
}
</script>
<style scoped>
  .overlay-content {
    background-color: white;
    border-radius: 15px;
    padding: 0.3rem;
    pointer-events: none;
  }
</style>
